// global app styling
import "./App.css";

// Material-UI imports
import { LocalizationProvider } from "@mui/x-date-pickers"; // Material-UI's LocalizationProvider
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // Dayjs adapter

// Custom imports
import Auth from "./components/Auth";
import Data from "./components/Data";
import ErrorBoundary from "./components/ErrorBoundary";
import ZRoutes, { ZRoutesContent } from "./Routes.jsx";
import { LLMSettingsProvider } from "./contexts/LLMSettingsContext.jsx"; // Import LLM context
import { TagProvider } from "./contexts/TagContext.jsx"; // Import Tag context

// New theme system
import { ThemeProvider } from "./contexts/ThemeContext.jsx"

// App content without router (for testing)
function AppContent() {
  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider>
          <LLMSettingsProvider>
            <Auth>
              <Data>
                <TagProvider>
                  <ZRoutesContent />
                </TagProvider>
              </Data>
            </Auth>
          </LLMSettingsProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  );
}

// Main App component (for production)
function App() {
  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider>
          <LLMSettingsProvider>
            <Auth>
              <Data>
                <TagProvider>
                  <ZRoutes />
                </TagProvider>
              </Data>
            </Auth>
          </LLMSettingsProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  );
}

export default App;
export { AppContent };
